export { default } from './HeroDual'
